import { render, staticRenderFns } from "./battlefield.vue?vue&type=template&id=532b7207&scoped=true&"
import script from "./battlefield.vue?vue&type=script&lang=js&"
export * from "./battlefield.vue?vue&type=script&lang=js&"
import style0 from "./battlefield.vue?vue&type=style&index=0&id=532b7207&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532b7207",
  null
  
)

export default component.exports